// extracted by mini-css-extract-plugin
export var chevron = "_a8-2";
export var dropdownItems = "_a8-0";
export var item = "_a8-1";